<template>
  <div style="padding: 16px;">
    <div>
      <p v-if="botList.ccr.length !== 0" style="color: #000000; font-size: 16px; font-weight: 800;">CCR机器人</p>

      <div v-for="eve in botList.ccr" :title="index" @click="onBotItemClick(eve)">

        <div style="border-radius: 4px; margin: 10px 0; padding: 12px 18px; background-color: #fff">
          <van-image
            width="24"
            height="24"
            src="https://bs-image-host.oss-cn-guangzhou.aliyuncs.com/logo/ccr-logo.png"
            style="vertical-align: middle; margin-right: 10px;"
          />
          <span v-if="!eve.remark" style=" vertical-align: middle; font-size: 14px;">{{ eve.phone_number }}</span>
          <span v-else="eve.remark" style="vertical-align: middle; font-size: 14px;">{{eve.remark}}<span style="font-size: 14px;">({{ eve.phone_number }})</span></span>
          <span v-if="eve.is_observation === true"
            style="margin-left: 10px ;width: 30px; height: 14px; background: #159BD4; border-radius: 2px; font-size: 10px;color: #FFFFFF; display: inline-block; text-align: center; line-height: 14px;">观摩</span>
          <span v-if="eve.platform === 2"
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(240,185,11,0.1); border-radius: 2px; font-size: 10px;color: #F0B90B; display: inline-block; text-align: center; line-height: 14px;">BIAN</span>
          <span v-else-if="eve.platform === 1"
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(0,92,244,0.1); border-radius: 2px; font-size: 10px;color: #005CF4; display: inline-block; text-align: center; line-height: 14px;">OKX</span>
          <span v-else-if="eve.platform === 3"
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(105,223,162,0.1); border-radius: 2px; font-size: 10px;color: #69dfa2; display: inline-block; text-align: center; line-height: 14px;">GATE</span>
          <span v-else-if="eve.platform === 4"
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(61,138,208,0.1); border-radius: 2px; font-size: 10px;color: #3d8ad0; display: inline-block; text-align: center; line-height: 14px;">HUOBI</span>
          <span v-else
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(224,86,98,0.1); border-radius: 2px; font-size: 10px;color: #e05662; display: inline-block; text-align: center; line-height: 14px;">未知</span>

          <div style="vertical-align: middle; float: right">
            <van-popover v-model:show="showPopoverMapping[eve.sn]" :actions="getActions(eve)" @select="(action) => onBotSelect(action, eve)" placement="bottom">
              <template #reference>
                <van-icon name="ellipsis" size="22" @click.stop="showPopoverMapping[eve.sn]=!showPopoverMapping[eve.sn]"/>
              </template>
            </van-popover>
          </div>
        </div>
      </div>

    </div>
    <div style="margin-top: 16px;">
      <p v-if="botList.ccg.length !== 0" style="color: #000000; font-size: 16px; font-weight: 800; margin-top: 8px;">CCG机器人</p>

      <div v-for="eve in botList.ccg" :title="index" @click="onBotItemClick(eve)">

        <div style="border-radius: 4px; margin: 10px 0; padding: 12px 18px; background-color: #fff">
          <van-image
            width="24"
            height="24"
            src="https://bs-image-host.oss-cn-guangzhou.aliyuncs.com/logo/ccg-logo.png"
            style="vertical-align: middle; margin-right: 10px;"
          />
          <span v-if="!eve.remark" style=" vertical-align: middle; font-size: 14px;">{{ eve.phone_number }}</span>
          <span v-else="eve.remark" style="vertical-align: middle; font-size: 14px;">{{eve.remark}}<span style="font-size: 14px;">({{ eve.phone_number }})</span></span>
          <span v-if="eve.is_observation === true"
            style="margin-left: 10px ;width: 30px; height: 14px; background: #159BD4; border-radius: 2px; font-size: 10px;color: #FFFFFF; display: inline-block; text-align: center; line-height: 14px;">观摩</span>
          <span  v-if="eve.platform === 2"
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(240,185,11,0.1); border-radius: 2px; font-size: 10px;color: #F0B90B; display: inline-block; text-align: center; line-height: 14px;">BIAN</span>
          <span v-else-if="eve.platform === 1"
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(0,92,244,0.1); border-radius: 2px; font-size: 10px;color: #005CF4; display: inline-block; text-align: center; line-height: 14px;">OKX</span>
          <span v-else-if="eve.platform === 3"
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(105,223,162,0.1); border-radius: 2px; font-size: 10px;color: #69dfa2; display: inline-block; text-align: center; line-height: 14px;">GATE</span>
          <span v-else-if="eve.platform === 4"
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(61,138,208,0.1); border-radius: 2px; font-size: 10px;color: #3d8ad0; display: inline-block; text-align: center; line-height: 14px;">HUOBI</span>
          <span v-else
            style="margin-left: 10px ;width: 30px; height: 14px; background: rgba(224,86,98,0.1); border-radius: 2px; font-size: 10px;color: #e05662; display: inline-block; text-align: center; line-height: 14px;">未知</span>
          <div style="vertical-align: middle; float: right">
            <van-popover v-model:show="showPopoverMapping[eve.sn]" :actions="getActions(eve)" @select="(action) => onBotSelect(action, eve)" placement="bottom">
              <template #reference>
                <van-icon name="ellipsis" size="22" @click.stop="showPopoverMapping[eve.sn]=!showPopoverMapping[eve.sn]"/>
              </template>
            </van-popover>
          </div>
        </div>
      </div>

    </div>

    <van-button @click="onAddNewBotClick"
                style="text-align: center; font-size: 14px; border-radius: 4px;border: none; border-color: #159BD4; height: 50px; background-color: #159BD4; padding-top: 4px; margin-top: 20px;"
                type="primary" block>
      <svg style="vertical-align: middle; margin-bottom: 4px;" t="1741576291033" class="icon" viewBox="0 0 1024 1024" version="1.1"
           xmlns="http://www.w3.org/2000/svg" p-id="5140" width="18" height="18">
        <path
          d="M511.445333 64c-217.429333 0-408.234667 158.549333-442.197333 380.074667-37.546667 244.522667 130.304 473.173333 374.826667 510.72 23.04 3.498667 45.909333 5.205333 68.48 5.205333 217.429333 0 408.234667-158.549333 442.197333-380.074667 37.546667-244.522667-130.304-473.173333-374.826667-510.72a451.584 451.584 0 0 0-68.48-5.205333m0 64c19.498667 0 39.253333 1.536 58.752 4.48a382.72 382.72 0 0 1 251.306667 152.32 382.72 382.72 0 0 1 69.973333 285.44 382.464 382.464 0 0 1-130.56 234.069333 383.829333 383.829333 0 0 1-558.421333-65.109333 382.72 382.72 0 0 1-69.973333-285.44A382.464 382.464 0 0 1 263.04 219.733333 383.829333 383.829333 0 0 1 511.445333 128"
          fill="#ffffff" p-id="5141"></path>
        <path
          d="M512 320a32 32 0 0 1 31.701333 27.648l0.298667 4.352v128h128a32 32 0 0 1 31.701333 27.648L704 512a32 32 0 0 1-27.648 31.701333l-4.352 0.298667h-128v128a32 32 0 0 1-27.648 31.701333L512 704a32 32 0 0 1-31.701333-27.648l-0.298667-4.352v-128h-128a32 32 0 0 1-31.701333-27.648L320 512a32 32 0 0 1 27.648-31.701333l4.352-0.298667h128v-128a32 32 0 0 1 27.648-31.701333L512 320z"
          fill="#ffffff" p-id="5142"></path>
      </svg>
      添加新的机器人
    </van-button>
    <p style="float: right; color: #159BD4; margin-top: 8px; font-size: 14px; text-decoration: underline;" @click="onAutoAddBotClick">一键添加观摩机器人</p>
  </div>
  <div style="height: 88px;"></div>

  <van-dialog v-model:show="showRemarkDialog" title="请输入您的备注" show-cancel-button @confirm="onRemarkConfirm" style="padding: 0 10px;" confirmButtonText="确认" confirmButtonColor="#159BD4">
    <van-field v-model="remarkValue" placeholder="支持中英文和数字，不超过16个字符" style="margin-top: 10px; padding: 0 20px;" />
    <p style="font-size: 10px; color: #cbcbcb; padding: 15px 15px;">备注仅自己可见，观摩机器人不支持备注。</p>
  </van-dialog>

</template>

<script setup>
import { botAPI } from '@/api';
import { showLoadingToast, closeToast, showNotify, showFailToast } from 'vant'
import { onMounted, ref } from 'vue';
import { showConfirmDialog } from 'vant';
import router from "@/router";
import { unbind } from "@/api/bot";

const showPopoverMapping = ref({})
// ----- 模型数据
const botList = ref({'ccr': [], 'ccg': []})
const showRemarkDialog = ref(false)
const remarkValue = ref('')
const currentBot = ref(null)

const onBotSelect = async (action, eve) => {
  if (action.text === "删除") {
    await onRemoveBotClick(eve)
  } else if (action.text === "备注") {
    currentBot.value = eve
    remarkValue.value = eve.remark || ''
    showRemarkDialog.value = true
  }
}

const onRemarkConfirm = async () => {
  if (!currentBot.value) return;
  // 判断remarkValue长度
  // 计算字符数：中文算2，英文/数字算1
  const getCharCount = (str) => {
    let count = 0;
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (code >= 0x4e00 && code <= 0x9fff) {
        count += 2; // 中文
      } else {
        count += 1; // 英文、数字、符号
      }
    }
    return count;
  };
  if (getCharCount(remarkValue.value) > 16) {
    showNotify('备注不能超过16个字符');
    return;
  }
  const toast = showLoadingToast({
    forbidClick: true,
    message: '保存中...',
  });
  try {
    const response = await botAPI.updateBotRemark(currentBot.value.id, remarkValue.value);
    if (response.code === 200) {
      showNotify({ type: 'success', message: '备注成功' });
      await updateBotList();
    } else {
      showNotify('备注失败: ' + response.msg);
    }
  } catch (error) {
    showNotify('备注失败');
  } finally {
    closeToast();
    showRemarkDialog.value = false;
  }
};

// 动态获取 actions
const getActions = (eve) => {
  if (eve.is_observation) {
    return [{ text: "删除" }];
  } else {
    return [{ text: "备注" }, { text: "删除" }];
  }
};

// ----- API 请求
const updateBotList = async () => {
  try {
    const toast = showLoadingToast({
      forbidClick: true,
      message: '加载中...',
    });
    const response = await botAPI.listAllBot();
    if (response.code !== 200) {
      showNotify({ type: 'warning', message: response.msg });
    } else {
      botList.value = response.data;
    }
    return response

  } catch (error) {
    // console.error('获取用户信息失败:', error);
    showNotify("请求订单列表接口失败！")
  } finally {
    closeToast();
  }
};

const onAutoAddBotClick = async () => {
  try {
    const toast = showLoadingToast({
      forbidClick: true,
      message: '加载中...',
    });
    const response = await botAPI.autoAddObservationBot();
    if (response.code !== 200) {
      showNotify("一键添加观摩机器人失败！" + response.msg)
    } else {
      if (response.data.new_count > 0) {
        showNotify({type: "success", "message": "一键添加成功"})
        await updateBotList()
        closeToast();
      } else {
        showFailToast("您已添加过观摩机器人");
      }

    }
    return response

  } catch (error) {
    // console.error('获取用户信息失败:', error);
    showNotify("一键添加观摩机器人失败！")
    closeToast();
  } finally {

  }
}


// ----- 方法
const onBotItemClick = (botItem) => {
  console.log(botItem.bot_type)
  // router.push('/profitoverview');
  router.push({path: '/profitdetails', query: {id: botItem.id}})
}

const onRemoveBotClick = (botItem) => {
  showConfirmDialog({
    title: '提示',
    message:
      '是否删除此机器人？',
    confirmButtonText: "确定",
    cancelButtonColor: "#999999",
    confirmButtonColor: "#159BD4"
  })
    .then(async () => {
      // on confirm
      try {
        const toast = showLoadingToast({
          forbidClick: true,
          message: '加载中...',
        });
        const response = await botAPI.unbind(botItem.id);
        if (response.code !== 200) {
          showNotify("删除失败！" + response.msg)
        } else {
          showNotify({type: "success", "message": "删除成功"})
          await updateBotList()
        }
        return response

      } catch (error) {
        // console.error('获取用户信息失败:', error);
        showNotify("删除失败！")
      } finally {
        closeToast();
      }

    })
    .catch(async () => {
      // on cancel
    });
}

const onAddNewBotClick = () => {
  router.push({path: '/addnewbot'})
}

onMounted(async () => {
  const result = await updateBotList();
});


</script>

<style scoped>
:deep(.van-popover__content) {
  width: 60px !important; /* 适当增加最小宽度 */
}

:deep(.van-popover__action) {
  width: 100% !important; /* 撑满容器 */
  justify-content: center !important; /* 文字居中 */
  font-size: 13px !important;
}
</style>